const emptyArray = Object.freeze([]);
export const alwaysArray = <T>(value?: T[]): readonly T[] =>
  value || emptyArray;
